var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"contents"},[_c('div',{staticClass:"login-base"},[_c('login-title',{attrs:{"type":_vm.showType},on:{"update:type":function($event){_vm.showType=$event}}}),_vm._v(" "),(_vm.showType == 1)?_c('user-login-by-phone'):_vm._e(),_vm._v(" "),(_vm.showType == 2)?_c('user-login-by-mail'):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98a647f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login.vue
// module id = null
// module chunks = 